import request from '@/utils/request'

let CompayApi = {

  /*公司列表*/
  list(data) {
    return request._post('/shop/plus.compay.Index/index', data);
},
  /*公司列表*/
  lista(data) {
    return request._post('/shop/plus.compay.Index/indexa', data);
},
getPeriodsByYear(data) {
    return request._post('/shop/plus.compay.Index/getPeriodsByYear', data);
},
getDetailsByPeriod(data) {
    return request._post('/shop/plus.compay.Index/getDetailsByPeriod', data);
},
approvePeriod(data) {
    return request._post('/shop/plus.compay.Index/approvePeriod', data);
},
rejectPeriod(data) {
    return request._post('/shop/plus.compay.Index/rejectPeriod', data);
},
/*添加公司*/
add(data) {
    return request._post('/shop/plus.compay.Index/add', data);
},
/*修改公司*/
edit(data) {
    return request._post('/shop/plus.compay.Index/edit', data);
},
/*删除公司*/
del(data) {
    return request._post('/shop/plus.compay.Index/del', data);
},
/*公司详情*/
detail(data) {
  return request._post('/shop/plus.compay.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.compay.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.compay.Setting/getSetting', data, errorback);
    },
    pass(data) {
        return request._post('/shop/plus.compay.Index/pass', data);
      },
      /*发票申请-不通过*/
      nopass(data) {
        return request._post('/shop/plus.compay.Index/nopass', data);
      },
 
}
export default CompayApi;



// WEBPACK FOOTER //
// ./src/api/compay.js